<template>
    <FlexClassWrapper
        v-bind="$props"
    >
        <div
            :style="flexBasisStyles"
        >
            <slot />
        </div>
    </FlexClassWrapper>
</template>

<script>
// Class Wrappers
import FlexClassWrapper from '../../classWrappers/FlexClassWrapper';

// Mixins
import flexProps from '../../mixins/flex-props.js';

export default {
    name: 'FlexContainer',
    components: { FlexClassWrapper },
    mixins: [flexProps],
    props: {
        flexBasis: {
            type: Number,
            default: 0
        }
    },
    computed: {
        flexBasisStyles: function() {
            return this.flexBasis && { flexBasis: `${this.flexBasis}%` };
        },
    },
}
</script>
